import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

/**
 * Which ticket's timeline drawer is open. The drawer sits in the app layout, so any page (the
 * Releases, My work, the Claude Fleet runs) opens it by key; the timeline itself is read
 * through `useTicketTimelineService` (Pinia Colada).
 */
export const useTicketTimelineStore = defineStore('adx-ticket-timeline', () => {
  const openKey = ref<string | null>(null)
  const isLoading = ref(false)
  const error = ref<string | null>(null)

  const isOpen = computed(() => openKey.value !== null)
  const hasError = computed(() => error.value !== null)

  function open(key: string) {
    openKey.value = key
  }

  function close() {
    openKey.value = null
  }

  function clearError() {
    error.value = null
  }

  function reset() {
    openKey.value = null
    isLoading.value = false
    error.value = null
  }

  return { openKey, isLoading, error, isOpen, hasError, open, close, clearError, reset }
})
